import { SingleStudentView } from "../components/singleStudent/SingleStudentView";

export const SingleStudent = () => {
  return (
    <div>
      <SingleStudentView />
    </div>
  );
};
